import React, { useContext } from 'react';
import { getDatabase, ref, push } from 'firebase/database'; // Use Firebase real-time database methods
import { AuthUserContext } from '../../session';
import { CButton } from '@coreui/react'; // Assuming you're using CoreUI

const moodLevels = [
      { code: 'LA6568-5', display: 'Happy' },
      { code: 'LA6569-3', display: 'Sad' },
      { code: 'LA6570-1', display: 'Angry' },
      { code: 'LA6571-9', display: 'Anxious' },
      { code: 'LA6572-7', display: 'Calm' },
];

const MoodInput = ({ fetchLatestMoodData }) => {
      const authUser = useContext(AuthUserContext); // Get authenticated user context
      const db = getDatabase(); // Get reference to Firebase Real-Time Database

      // Function to save the mood observation to Firebase Real-Time Database
      const saveMoodObservation = async (moodCode, moodDisplay) => {
            try {
                  const moodRef = ref(db, `moodObservations/${authUser.authUser.uid}`); // Reference to moodObservations in real-time DB
                  await push(moodRef, {
                        userId: authUser.authUser.uid,
                        code: moodCode,
                        display: moodDisplay,
                        effectiveDateTime: new Date().toISOString(),
                  });
                  alert(`Mood "${moodDisplay}" recorded successfully!`);

                  // Fetch latest mood data after successfully saving
                  if (fetchLatestMoodData) {
                        fetchLatestMoodData(); 
                  }
            } catch (error) {
                  console.error('Error adding mood observation: ', error);
            }
      };

      return (
            <div style={{ margin: '20px 0' }}>
                  <h3>How are you feeling today?</h3>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {moodLevels.map(level => (
                              <CButton
                                    key={level.code}
                                    color="primary"
                                    onClick={() => saveMoodObservation(level.code, level.display)}
                              >
                                    {level.display}
                              </CButton>
                        ))}
                  </div>
            </div>
      );
};

export default MoodInput;
